var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"optimization-page"},[_c('back-to-top',{attrs:{"custom-style":_vm.myBackToTopStyle,"visibility-height":300,"back-position":0,"transition-name":"fade"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }